import React from 'react';
import { CrewContact, Itinerary } from 'acscp/store';
import { FormattedMessage } from 'react-intl';
import style from './sharedItinerary.module.scss';
import { LabeledItem } from 'acscp/components/common/labeledItem';
import { withCollapsable } from 'acscp/components/common/collapsable';
import { Title } from 'acscp/components/itinerary/collapsableSections';
import { isEmpty } from 'acscp/components/common/helpers/isEmpty';

interface CrewDetailsContentProps {
    captain: CrewContact;
    firstOfficer: CrewContact;
    flightAttendant: CrewContact;
}

const CrewContactDetails: React.SFC<{ label: JSX.Element, crew: CrewContact }> = ({ label, crew }) => {
    if (isEmpty(crew)) {
        return null;
    }
    return (
        <div className={style.ItemContainer}>
            <LabeledItem label={label} linebreak={true}>
                {crew.name}
            </LabeledItem>
            <LabeledItem
                label={<FormattedMessage id={'web.components.itinerary.crew.telephone'} defaultMessage={'T'} />}
            >
                {crew.telephone}
            </LabeledItem>
        </div>
    );
};

const CrewDetailsContent: React.SFC<CrewDetailsContentProps> = ({captain, firstOfficer, flightAttendant}) => {

    if (isEmpty(captain) && isEmpty(firstOfficer) && isEmpty(flightAttendant)) {
        return null;
    }
    return (
        <div className={style.Container}>
            <div className={style.InnerContainer}>
                <CrewContactDetails
                    label={
                        <FormattedMessage
                            id={'web.components.itinerary.crew.captain'}
                            defaultMessage={'Captain'}
                        />}
                    crew={captain}
                />
                <CrewContactDetails
                    label={
                        <FormattedMessage
                            id={'web.components.itinerary.crew.firstOfficer'}
                            defaultMessage={'First Officer'}
                        />}
                    crew={firstOfficer}
                />
                <CrewContactDetails
                    label={<FormattedMessage
                        id={'web.components.itinerary.crew.flightAttendant'}
                        defaultMessage={'Flight Attendant'}
                    />}
                    crew={flightAttendant}
                />
            </div>
        </div>
    );
};

const CrewDetails = withCollapsable(
    (
        <Title>
            <FormattedMessage
                id={'web.components.itinerary.crewDetailsTitle'}
                defaultMessage={'CREW DETAILS'}
            />
        </Title>
    ),
    CrewDetailsContent);
export { CrewDetails };
